<template>
  <div>
    <div v-if="resultsLoading && latest" :class="`loading-dots ${role}`" :style="`color: ${config.primary_color || '#9747ff'}`">
      <svg width="100" height="20" viewBox="0 0 100 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
        <circle v-for="n in 5" :key="n" :cx="10 + (n - 1) * 18" cy="10" r="6">
          <animate attributeName="opacity" from="1" to="1" :begin="`${n * .15}s`" dur="1s" values="1;0.4;1"
            calcMode="linear" repeatCount="indefinite" />
        </circle>
      </svg>
    </div>
    <div v-if="content.length" :class="`message ${role}`" :style="`background: ${config.secondary_color}15`">
      <div v-if="role === 'assistant'" class="icon assistant">
        <div :style="`width: ${config.icon_dimensions.width}; height: ${config.icon_dimensions.height}`">
          <img :src="iconPath" alt="assistant icon"/>
        </div>
      </div>
      <div class="content">
        <!-- <p>{{ `this content is ${content.length} long: ${content}` }}</p> -->
        <div class="formatted-content" v-html="formattedContent"></div>
        
        <div class="products-wpr" v-if="products.length">
          <ChatbotProduct v-for="product in parsedProducts" :key="product.sku" :product="product" />
        </div>
      </div>
      <div v-if="role === 'user'" class="icon user">
        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"
          :style="`color: ${config.primary_color || '#9747ff'}`">
          <path
            d="M13.333 1.333H2.673c-.733 0-1.333.6-1.333 1.334l-.007 12L4 12h9.333c.734 0 1.334-.6 1.334-1.333v-8c0-.734-.6-1.334-1.334-1.334ZM8 4c.733 0 1.333.6 1.333 1.333 0 .734-.6 1.334-1.333 1.334s-1.333-.6-1.333-1.334C6.667 4.6 7.267 4 8 4Zm2.667 5.333H5.333v-.38c0-.54.32-1.02.814-1.233a4.634 4.634 0 0 1 3.706 0c.494.213.814.693.814 1.233v.38Z"
            fill="currentColor" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ChatbotProduct from './ChatbotProduct.vue'

export default {
  components: {
    ChatbotProduct
  },
  props: {
    role: {
      type: String,
      required: true
    },
    content: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      default: () => []
    },
    latest: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('config', ['features']),
    ...mapState('search', ['resultsLoading']),

    config() {
      return this.features.chatbot || {};
    },

    parsedProducts() {
      return this.products.filter(product => product && product.sku);
    },
    
    formattedContent() {
      if (!this.content) return '';
      
      // Replace /n with proper line breaks
      let formatted = this.content.replace(/\\n/g, '<br>');
      
      // Handle bold text wrapped in double asterisks
      formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      
      // Convert numbered lists (e.g., "1.", "2.", etc) with proper structure
      formatted = formatted.replace(/(\d+\.)\s(.*?)(?=(?:\d+\.|$))/g, (match, number, content) => {
        return `<div class="list-item"><span class="list-marker">${number}</span><span class="list-content">${content.trim()}</span></div>`;
      });
      
      return formatted;
    },

    iconPath() {
      return '/icons/' + this.config.icon;
    }
  }
}
</script>

<style>
.loading-dots {
  &.user {
    text-align: right;
  }
}

.message {
  margin: 8px;
  display: flex;
  gap: 8px;
  white-space: pre-wrap;
  padding: 12px 18px;
  width: fit-content;
  max-width: 85%;
  border-radius: 16px;

  &.user {
    margin-left: auto;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .formatted-content {
      :deep(br) {
        display: block;
        margin: 8px 0;
      }

      :deep(.list-item) {
        display: flex;
        gap: 8px;
        margin: 8px 0;
      }

      :deep(.list-marker) {
        font-weight: 600;
        color: var(--primary-color, #9747ff);
        flex-shrink: 0;
      }

      :deep(.list-content) {
        flex: 1;
      }

      :deep(strong) {
        font-weight: 600;
        color: var(--primary-color, #9747ff);
      }
    }
  }

  .products-wpr {
    background: #FFFFFF;
    margin-top: 16px;
    padding: 10px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 16px;
  }
  
  .icon {
    flex-shrink: 0;
    height: 32px;
    border-radius: 50%;
    display: grid;
    place-items: center;

    &.user {
      width: 32px;
      background: #FFFFFF;
    }

    &.assistant {
      height: 38px;
      width: 47px;
      margin-top: 4px;

      div {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
</style>